import { all } from 'redux-saga/effects'
import signupCompCreateSaga from "../modules/companyCreationLayout//data/saga"

export default function* rootSaga() {
  yield all([
    signupCompCreateSaga()
  ])
} 